import React from 'react';
import PropTypes from 'prop-types';

const Typography = ({
  className = '',
  copyText = false,
  Tag,
  bold,
  sub,
  pNumber,
  text,
  children,
  html,
  light,
  tabIndex,
}) => {
  const classNameList = {
    h1: 'heading-one',
    h2: 'heading-two',
    h3: 'heading-three',
    h4: !sub ? 'heading-four' : 'sub-heading-one',
    h5: !sub ? 'heading-five' : 'sub-heading-two',
    h6: !sub ? 'heading-six' : 'sub-heading-three',
    p1: 'body-one',
    p2: 'body-two',
    p3: 'body-three',
    p4: 'body-four',
    p5: 'body-five',
    p6: 'body-six',
  };

  const block = {
    h1: 'heading',
    h2: 'heading',
    h3: 'heading',
    h4: 'heading',
    h5: !sub ? 'heading' : 'sub-heading',
    h6: !sub ? 'heading' : 'sub-heading',
    p1: 'body',
    p2: 'body',
    p3: 'body',
    p4: 'body',
    p5: 'body',
    p6: 'body',
  };

  const base = !pNumber ? block[Tag] : block[Tag + pNumber];

  const type = !pNumber ? classNameList[Tag] : classNameList[Tag + pNumber];

  let customClass = `cl-${base} cl-${type} ${className}`;

  if (bold) {
    customClass += ` cl-${type}-bold`;
  }

  if (light) {
    customClass += ` cl-${type}-light`;
  }

  if (copyText) {
    customClass += ' cl-copy-text';
  }

  const htmlContentProps = html ? { dangerouslySetInnerHTML: { __html: html } } : {};

  return (
    <Tag className={customClass} tabIndex={tabIndex} {...htmlContentProps}>
      {text || children}
    </Tag>
  );
};

Typography.propTypes = {
  bold: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.node,
  copyText: PropTypes.bool,
  html: PropTypes.string,
  pNumber: PropTypes.number,
  sub: PropTypes.bool,
  Tag: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'strong']),
  text: PropTypes.string,
  light: PropTypes.bool,
  tabIndex: PropTypes.number,
};

Typography.defaultProps = {
  bold: false,
  className: null,
  children: null,
  copyText: false,
  html: null,
  pNumber: null,
  sub: false,
  Tag: 'h1',
  text: null,
  light: false,
};

export default Typography;
